var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"czSegments",attrs:{"role":"img","aria-label":_vm.label}},_vm._l((_vm.states),function(state,index){return _c('span',{key:index,staticClass:"czSegments__part",class:'is-' + state})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }